// Copyright (c) Bentley Systems
export class LegendHighlight {
  public highlightId: number | undefined;
  public caption: string | undefined;
  public description: string | undefined;
  public styleId: string | undefined;
  public styleData: string | undefined;
}
